import styles from './style.module.css';

export const ButtonLoader = () => {
  return (
    <div className={styles.loader}>
      <div className={styles.ballSpinFadeLoader}>
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};
